export const xml2json = xmlstr => {
  //将xml字符串转为json
  var xotree = new XML.ObjTree();
  var xmlText = document.getElementById("xml").value;
  var json = xotree.parseXML(xmlText);
  //将json对象转为格式化的字符串
  var dumper = new JKL.Dumper();
  var jsonText = dumper.dump(json);
  document.getElementById("json").value = jsonText;
}

export const filterParams = params => {
  if (Object.prototype.toString.call(params) === '[object Object]') {
    for (var key in params) {
      if (params[key] === undefined) {
        delete params[key];
      } else if (typeof params[key] === 'string') {
        (params[key] = trim(params[key])) === '' && delete params[key];
      } else if (params[key] instanceof Date) {
        // params[key] = DateFormat(params[key]);
      } else if (typeof params[key] === 'object') {
        params[key] = filterParams(params[key]);
      }
    }
  }
  return params;
};

export const DateFormat = (date, fmt = 'yyyy-MM-dd HH:mm:ss') => {
  date = new date(date);
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}
//jxx 获取当前时间 格式：2017-05-20 14:24:21
export const GetTime = () => {
  function checkNum(num) {
    if (num < 10) {
      return "0" + num;
    }
    else {
      return num;
    }
  }
  var mydate = new Date();
  var str = "" + mydate.getFullYear() + "-";
  str += checkNum(mydate.getMonth() + 1) + "-";
  str += checkNum(mydate.getDate()) + " ";
  str += checkNum(mydate.getHours()) + ":";
  str += checkNum(mydate.getMinutes()) + ":";
  str += checkNum(mydate.getSeconds()) + "";
  return str;
}
//jxx 日期格式化
export const formatDate = (v, format = 'yyyy-MM-dd HH:mm:ss') => {
  if (!v) return "";
  var d = v;
  if (typeof v === 'string') {
    if (v.indexOf("/Date(") > -1)
      d = new Date(parseInt(v.replace("/Date(", "").replace(")/", ""), 10));
    else
      d = new Date(Date.parse(v.replace(/-/g, "/").replace("T", " ").split(".")[0])); //.split(".")[0] 用来处理出现毫秒的情况，截取掉.xxx，否则会出错
  }
  var o = {
    "M+": d.getMonth() + 1, //month
    "d+": d.getDate(), //day
    "H+": d.getHours(), //hour
    "m+": d.getMinutes(), //minute
    "s+": d.getSeconds(), //second
    "q+": Math.floor((d.getMonth() + 3) / 3), //quarter
    "S": d.getMilliseconds() //millisecond
  };
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
}

function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

//过滤左右空格
function trim(str) {
  if (!str) return str;
  return str.replace(/(^\s*)|(\s*$)/g, '');
}

export const setLoginUserInfo = user => {
  localStorage.setItem('userInfo', JSON.stringify(user));
};

export const getLoginUserInfo = () => {
  const userInfoStr = localStorage.getItem('userInfo') || '{}';
  return JSON.parse(userInfoStr);
};

export const buildOrganizeTree = (data) => {
  if (data.listOrganize && data.listOrganize.length > 0) {
    data.children = data.listOrganize;
  }
  data.listOrganize.map(item => {
    buildOrganizeTree(item);
  });
  return data;
};

export const copyToClipboard = (elm) => {
  const Url2 = elm.innerText;
  const oInput = document.createElement('input');
  oInput.value = Url2;
  document.body.appendChild(oInput);
  oInput.select(); // 选择对象
  document.execCommand("Copy"); // 执行浏览器复制命令
  oInput.style.display = 'none';
};

//获取指定名称的cookie的值
export const getCookie = (objName) => {
  var arrStr = document.cookie.split("; ");
  for (var i = 0; i < arrStr.length; i++) {
    var temp = arrStr[i].split("=");
    if (temp[0] == objName) return unescape(temp[1]);
  }
}

/**
 * 设置cookie
 * @param {string} objName cookie的name
 * @param {string} objValue 值
 * @param {number} objHours 过期时间（0永不过期，关闭浏览器过期）
 * @param {string} local cookie有效的域名，二级域名间跨域使用cookie时，需要填写该字段
 */
export const setCookie = (objName, objValue, objHours, local) => {
  var str = objName + "=" + escape(objValue);
  if (objHours > 0) {//为0时不设定过期时间，浏览器关闭时cookie自动消失
    var date = new Date();
    var ms = 24 * 60 * 60 * 1000; //自己设置cookie时间
    date.setTime(date.getTime() + ms); //注意为毫秒值
    str += "; expires=" + date.toGMTString();
  }
  str += ";path=/;domain=" + local || "";
  document.cookie = str;
}


/**
 * 清空cookie
 * @param {string} local 二级域名间跨域使用cookie时，需要填写该字段
 */
export const clearAllCookie = (local) => {
  var date = new Date();
  date.setTime(date.getTime() - 10000);
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--;)
      document.cookie = keys[i] + "=0; expire=" + date.toGMTString() + "; path=/" + local ? ";domain=" + local : "";
  }
}

//生成guid
export const guid = () => {
  const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  return ("guid_" + S4() + S4() + "_" + S4() + "_" + S4() + "_" + S4() + "_" + S4() + S4());
}


//jxx 判断是否为空值  空==true  非空==false
export const IsNullOrEmpty = (str) => {
  var isOK = false;
  if (str === "undefined" || str === undefined || str === "" || str === null || str === "null") {
    isOK = true;
  }
  return isOK;
}

//jxx 格式化金额   fmoney("12345.675910", 3)，返回12,345.676
export const formatMoney = (s, n = 0) => {
  if (IsNullOrEmpty(s)) return ""
  n = n > -1 && n <= 20 ? n : 2;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
  var l = s.split(".")[0].split("").reverse(), r = n === 0 ? "" : s.split(".")[1];
  let t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
  }
  return t.split("").reverse().join("") + (n === 0 ? "" : ".") + r;
}

/** jxx json数组合并去重
 * @param {Array} jsonA 要合并的数组A
 * @param {Array} jsonB 要合并的数组B
 * @param {string} key 要匹配去重的主键key
 */
export const jsonArrayConcat = (jsonA, jsonB, key) => {
  var c = jsonA.concat(jsonB),//合并成一个数组
    temp = {},//用于id判断重复
    result = [];//最后的新数组
  //遍历c数组，将每个item.id在temp中是否存在值做判断，
  c.map((item, index) => {
    if (!temp[item[key]]) {
      result.push(item);
      temp[item[key]] = true
    }
  })
  return result;
}

/**
 * 时间戳格式化
 * @param {number} timeStr 时间戳
 */
export const GetTimeStr2Format = (timeStr) => {
  var date = new Date(parseInt(timeStr));
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}

//获取url参数
export const getUrlParam = (name) => {
  //构造一个含有目标参数的正则表达式对象
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  //匹配目标参数
  var r = window.location.search.substr(1).match(reg);
  //返回参数值
  if (r != null) return unescape(r[2]);
  else return "";
}

export const NumberCompute = {
	/**
	 * jxx 加法运算
	 * @param {Number} 数字1
	 * @param {Number} 数字2
	 * @return {Number} 运算结果
	 */
  add: function (a, b) {
    var c, d, e;
    try {
      c = a.toString().split(".")[1].length;
    } catch (f) {
      c = 0;
    }
    try {
      d = b.toString().split(".")[1].length;
    } catch (f) {
      d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) + this.mul(b, e)) / e;
  },
	/**
	 * jxx 减法运算
	 * @param {Number} 数字1
	 * @param {Number} 数字2
	 * @return {Number} 运算结果
	 */
  sub: function (a, b) {
    var c, d, e;
    try {
      c = a.toString().split(".")[1].length;
    } catch (f) {
      c = 0;
    }
    try {
      d = b.toString().split(".")[1].length;
    } catch (f) {
      d = 0;
    }
    return e = Math.pow(10, Math.max(c, d)), (this.mul(a, e) - this.mul(b, e)) / e;
  },
	/**
	 * jxx 乘法运算
	 * @param {Number} 数字1
	 * @param {Number} 数字2
	 * @return {Number} 运算结果
	 */
  mul: function (a, b) {
    var c = 0,
      d = a.toString(),
      e = b.toString();
    try {
      c += d.split(".")[1].length;
    } catch (f) { }
    try {
      c += e.split(".")[1].length;
    } catch (f) { }
    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
  },
	/**
	 * jxx 除法运算
	 * @param {Number} 数字1
	 * @param {Number} 数字2
	 * @return {Number} 运算结果
	 */
  div: function (a, b) {
    var c, d, e = 0,
      f = 0;
    try {
      e = a.toString().split(".")[1].length;
    } catch (g) { }
    try {
      f = b.toString().split(".")[1].length;
    } catch (g) { }
    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), this.mul(c / d, Math.pow(
      10,
      f - e));
  }
};



// WEBPACK FOOTER //
// ./src/utils/m-utils.js